import axiosInstance from '../../helpers/axios';
import {
  Coupon,
  CouponAdminStats,
  CouponDetail,
  CouponRedemption,
  CouponWithStatus,
  CreateCouponPayload,
  DeleteCouponResult,
  ListCouponsAdminParams,
  ListRedemptionsParams,
  Paginated,
  SetCouponStatusPayload,
  UpdateCouponPayload,
} from './coupons.types';

const BASE = '/coupons';

async function listCouponsAdmin(
  params: ListCouponsAdminParams = {},
): Promise<Paginated<CouponWithStatus>> {
  const response = await axiosInstance.get(`${BASE}/admin`, { params });
  return response.data.data;
}

async function getAdminStats(): Promise<CouponAdminStats> {
  const response = await axiosInstance.get(`${BASE}/admin/stats`);
  return response.data.data;
}

async function getCouponAdmin(id: string): Promise<CouponDetail> {
  const response = await axiosInstance.get(`${BASE}/admin/${id}`);
  return response.data.data;
}

async function getRedemptionsAdmin(
  id: string,
  params: ListRedemptionsParams = {},
): Promise<Paginated<CouponRedemption>> {
  const response = await axiosInstance.get(`${BASE}/admin/${id}/redemptions`, { params });
  return response.data.data;
}

async function createCoupon(payload: CreateCouponPayload): Promise<Coupon> {
  const response = await axiosInstance.post(BASE, payload);
  return response.data.data;
}

async function updateCouponAdmin(id: string, payload: UpdateCouponPayload): Promise<CouponWithStatus> {
  const response = await axiosInstance.patch(`${BASE}/admin/${id}`, payload);
  return response.data.data;
}

async function deleteCouponAdmin(id: string): Promise<DeleteCouponResult> {
  const response = await axiosInstance.delete(`${BASE}/admin/${id}`);
  return response.data.data;
}

async function setCouponStatus(
  id: string,
  payload: SetCouponStatusPayload,
): Promise<CouponWithStatus> {
  const response = await axiosInstance.patch(`${BASE}/admin/${id}/status`, payload);
  return response.data.data;
}

async function duplicateCoupon(id: string): Promise<Coupon> {
  const response = await axiosInstance.post(`${BASE}/admin/${id}/duplicate`);
  return response.data.data;
}

export const couponsService = {
  listCouponsAdmin,
  getAdminStats,
  getCouponAdmin,
  getRedemptionsAdmin,
  createCoupon,
  updateCouponAdmin,
  deleteCouponAdmin,
  setCouponStatus,
  duplicateCoupon,
};
